import React from 'react';
import { cn } from '@/utils/cn';
import DOMPurify from 'dompurify';
import styles from './styles/typography.module.css';

function SafeHTML({ html, className = '' }) {
  const sanitizedHTML = DOMPurify.sanitize(html || '');

  return (
    <div
      className={cn(`${styles.prose}`, className)}
      dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
    />
  );
}

export default SafeHTML;
